import React from 'react';
import { ArrowDownRightIcon, ArrowUpRightIcon, MinusIcon } from 'lucide-react';
import { fmtPP, fmtSignedPct } from '../../utils/format';
interface DeltaBadgeProps {
  value: number | null;
  kind: 'pct' | 'pp';
  label?: string;
}
export function DeltaBadge({
  value,
  kind,
  label
}: DeltaBadgeProps) {
  if (value === null || !isFinite(value)) {
    return <span className="text-xs text-ink-subtle" data-id="element-653" data-mp="27u0h4q176450">{label ? `${label} n/a` : 'n/a'}</span>;
  }
  const up = value > 0.0005;
  const down = value < -0.0005;
  const color = up ? 'text-positive' : down ? 'text-negative' : 'text-ink-muted';
  const Icon = up ? ArrowUpRightIcon : down ? ArrowDownRightIcon : MinusIcon;
  return <span className={`inline-flex items-center gap-0.5 whitespace-nowrap text-xs font-medium tabular-nums ${color}`} data-id="element-654" data-mp="2rfvhr179rg1p">
      <Icon className="h-3 w-3" aria-hidden data-id="element-655" data-mp="35f4qxgx259w6" />
      {kind === 'pp' ? fmtPP(value) : fmtSignedPct(value)}
      {label && <span className="ml-1 font-normal text-ink-subtle" data-id="element-656" data-mp="30hmhlpf4osnn">{label}</span>}
    </span>;
}